import { SNACKBAR_MODULE } from '../store/modules'
import { createNamespacedHelpers } from 'vuex'
import { SNACKBAR_OPEN } from '../store/actions'

const { mapActions } = createNamespacedHelpers(SNACKBAR_MODULE)

export default {
  methods: {
    ...mapActions([SNACKBAR_OPEN]),
    openDefaultSnackbar (text) {
      this[SNACKBAR_OPEN]({ text })
    },
    openSuccessSnackbar (text) {
      const color = 'success'
      this[SNACKBAR_OPEN]({ text, color })
    },
    openFailureSnackbar (text) {
      const color = 'error'
      this[SNACKBAR_OPEN]({ text, color })
    },
    processFailedRequest(error) {
      if (error.hasOwnProperty('details')) {
        this.openFailureSnackbar(error.details)
      }
    }
  }
}
